export const SPECIAL_OFFER_TEXTS = [
  {
    text: (
      <>
        Na sua próxima fatura, o <strong>valor será proporcional</strong> aos dias de uso de cada
        plano.
      </>
    ),
  },
  {
    text: (
      <>
        Fidelidade de <strong>12 meses</strong>
      </>
    ),
  },
  {
    text: (
      <>
        A mudança será realizada em até <strong>2 dias úteis</strong>
      </>
    ),
  },
  {
    text: (
      <>
        Você receberá uma <strong>confirmação por SMS</strong>
      </>
    ),
  },
]
